var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"404","title":"404","sub-title":"页面不存在，请检查网址是否输入正确！"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(" 返回上一层 ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }